<template>
    <div>
        <div class="commonSearch bottom" ref="commonSearchRef">
            <el-form class="el-form el-form--inline" style="margin-top: 10px;margin-bottom: 10px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="报修单号：">
                            <el-input v-model="form.repaircode" placeholder="模糊匹配" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="学生校区：">
                            <el-select v-model="form.region" clearable @change="handleSelectionChange" placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in xqqys" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="楼宇：">
                            <el-select v-model="form.buliding" clearable placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in lys" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="6">
                        <el-form-item label="故障类型：">
                            <el-select v-model="form.faulttype" clearable placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in gzlxs" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" @click="initData">查询</el-button>
                        <el-button type="primary" plain @click="form = {}">清空</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div class="commonTable">
            <el-table :data="returndata" ref="datas" :row-class-name="tableRowClassName" size="medium" v-loading="loading" element-loading-text="拼命加载中" :header-cell-style="{background: '#FAFAFA', color: '#000000', borderRight: '1px solid #fff'}" :height="tabHeight">
                <el-table-column prop="repaircode" label="报修单号" min-width="130"> </el-table-column>
                <el-table-column prop="regionName" label="学生校区" min-width="80"> </el-table-column>
                <el-table-column prop="bulidingName" label="楼宇" min-width="120"> </el-table-column>
                <el-table-column prop="faulttypeName" label="故障类型" min-width="120"> </el-table-column>
                <el-table-column prop="statusName" label="状态" min-width="80"> </el-table-column>
                <el-table-column prop="changeCount" label="转单次数" min-width="80"> </el-table-column>
                <el-table-column prop="changeTime" label="转单时间" min-width="80"> </el-table-column>
                <el-table-column prop="repersonnel" label="接单工程师" min-width="80"> </el-table-column>
                <el-table-column prop="huregionName" label="接单工程师校区" min-width="120"> </el-table-column>
                <el-table-column prop="ostatus" label="派单状态" min-width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.ostatus == 1">未接单</span>
                        <span v-if="scope.row.ostatus == 2">已接单</span>
                        <span v-if="scope.row.ostatus == 3">已完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createdate" label="报修时间" min-width="150"> </el-table-column>

                <el-table-column prop="faulttype" label="操作" min-width="110">
                    <template slot-scope="scope">
                        <span class="caozuo" @click="toOrderView(scope.row)">明细</span>
                        <span class="caozuo" @click="acceptOrder(scope.row)" v-if="scope.row.ostatus == 1 || scope.row.ostatus == null">&emsp;|&emsp;接单</span>
                        <span class="caozuo" @click="completed(scope.row)" v-if="scope.row.ostatus==2">&emsp;|&emsp;完成</span>
                        <span class="caozuo" @click="transferOrder(scope.row)" v-if="scope.row.ostatus == 1 || scope.row.ostatus == null">&emsp;|&emsp;转单</span>
                         <span class="caozuo" v-if="scope.row.ostatus != 0 && (scope.row.status == 100405||scope.row.status == 100402)" @click="toEvaluateView(scope.row)">&emsp;|&emsp;查看</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页框 -->
        <div class="commonPage" align="right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
        <div>
            <TransDlg v-if="TransDlgShow" ref="TransDlgRef"></TransDlg>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
import FaultApi from "@/api/fault.js";
import RepairsApi from "@/api/repairs.js";
import TransDlg from "./TransferOrder.vue";

export default {
    mixins: [TabResize],
    components: {
        TransDlg,
    },
    data () {
        return {
            form: {
                repaircode: "",
                region: "",
                buliding: "",
                faulttype: "",
            },
            orderid: "",
            options: [],
            loading: true,
            cur_page: 1,
            per_page: "",
            totalCount: 0,
            returndata: [],
            returndata2: [],
            gzlxs: [], //故障类型
            xqqys: [], //校区
            lys: [],//楼宇
            TransDlgShow: false,

        };
    },

    mounted: function () {
        this.initData();

        this.findOptions("1002", "gzlxs");
        this.findOptions("1003", "xqqys");
    },

    methods: {
        tableRowClassName({row}){
            if(row.changeCount != 0){
                return 'warning-row';
            }

        },
        transferOrder (row) {
            this.TransDlgShow = true;
            this.$nextTick(() => {
                this.$refs.TransDlgRef.init(row, this.tabName);
            });
        },
        toEvaluateView (row) {
            this.$router.push({
                name: "EvaluateView",
                params: { row }
            });
        },
        acceptOrder (row) {
            this.$confirm(
                "您确定接单吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info"
                }
            )
            .then(() => {
                FaultApi.getClass()
                    .acceptOrder(row.orderid)
                    .then((resp) => {
                        if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                            this.initData();
                        } else {
                            this.$message.error(resp.data.msg);
                            this.loading = false;
                            return false;
                        }
                    }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });

            })
            .catch(() => {

            });

        },
        completed (row) {
            this.$confirm(
                "该订单确定完成吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info"
                }
            )
                .then(() => {
                    FaultApi.getClass()
                        .completeOrder(row.orderid)
                        .then((resp) => {
                            if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                                this.initData();
                            } else {
                                this.$message.error(resp.data.msg);
                                this.loading = false;
                                return false;
                            }
                        }).catch((err) => {
                        this.loading = false;
                        this.$message.error(err);
                        return false;
                    });
                })
                .catch(() => {

                });
        },

        findOptions (code, key) {
            SettingApi.getClass()
                .Findcode(code)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this[key] = resp.data.data;
                        if(key == "xqqys"){
                            for(let i=0; i<this[key].length; i++){
                                    if(this[key][i].code == '100304'){
                                        this[key].splice(i, 1)
                                    }
                                 }
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        handleSelectionChange (v) {
            this.form.buliding = "";
            this.lys = [];
            if (v) {
                this.findOptions(v, "lys");
            }
        },

        toOrderView (row) {
            this.$router.push({
                name: "OrderView",
                params: { row },
            });
        },

        initData () {
            this.returndata = [];
            let param = {
                operType: "qryAcceptOrder",
                repairStatus: "1,2",
                repaircode: this.form.repaircode,
                region: this.form.region,
                buliding: this.form.buliding,
                faulttype: this.form.faulttype,
                pageNum: this.cur_page,
                pageSize: this.per_page
            };

            FaultApi.getClass()
                .findPages(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.totalCount = resp.data.data.totalElements;
                        this.returndata = resp.data.data.data;
                        this.loading = false;
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    this.loading = false;
                });
        },

        //切换每页显示多条
        handleSizeChange (val) {
            this.per_page = val;
            this.cur_page = 1;
            this.initData();
        },
        // 切换显示第几页
        handleCurrentChange (val) {
            this.cur_page = val;
            this.initData();
        }
    }
};
</script>

<style lang="stylus" scoped>
.bottom {
}

.caozuo {
    color: #3D84FF;
    cursor: pointer;
}

/deep/.el-button--small {
    margin-left: 20px;
}
/deep/.el-table .warning-row {
    background: oldlace;
}
</style>